// removed by extract-text-webpack-plugin
module.exports = {"box":"_2Jx7QzaI4wyzgKqU_UqWYB","boxHead":"In8jQ1-HGowSGF4LjML1h","shopName":"_2bvvObv3oagm0nSpxAEEDh","shopCat":"_1dan3o8tQ8znpK4Lznvnph","boxContent":"_3zJe7TzYwsBHPQh8zilt4o","infoDetail":"_2PuaZN6FxCQj0mGVx2V6MH","row":"_3aFOvcBV9_ivbE22V509U5","time":"aX71_cPxGTxouPDJXkub2","btnDetail":"eP7Qd8mKbqbhQHPMsntp1","total":"_1jUWyVGmXVM0_JwxaYB5mP","marginTop":"_1MQi5uYLufnU8ybGxG15nI","dash":"_2sajas_w5ofNZJ8CurXr_8"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/Common/Booking/PreviewBooking.scss
// module id = 1110
// module chunks = 0